import rootStore from "@/app/store";
import crud, { ApiResponse } from "../crud";

export const S3_URL =
  "https://a1d91567-6989-4fd0-853c-f63799386a9d.selstorage.ru";

export function S3API(baseUrl: string) {
  return {
    uploadFile: async (file: File) => {
      const formData = new FormData();
      formData.append("file", file);
      const businessProfileId =
        rootStore.getState().businessProfile.businessProfile.id;
      return (await crud.post(
        `${baseUrl}/s3/upload/?business_profile_id=${businessProfileId}`,
        formData,
        true,
        "auto",
      )) as ApiResponse<string>;
    },
    listFiles: async (businessProfileId: string, locationId?: string) => {
      return (await crud.get(
        `${baseUrl}/s3/?business_profile_id=${businessProfileId}${locationId ? `&location_id=${locationId}` : ""}`,
        undefined,
        true,
      )) as ApiResponse<string[]>;
    },
  };
}
